import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import * as lib from '~/dependencies';
import * as actionTypes from '~/store/actions/actionTypes';
import { colors } from '~/layout';

export default function TimerCount({
  answered,
  id,
  timerRinging,
  timerDuring,
  callStatus,
}) {
  const timer = answered ? timerDuring : timerRinging;
  const [timeNow, setTimeNow] = useState();

  function callCounter() {
    setTimeNow(timer.getTimeValues().toString());
  }

  useEffect(() => {
    if (timer && timer.isRunning()) {
      timer.on('secondsUpdated', callCounter);
    } else if (
      timer &&
      (callStatus === actionTypes.CALL_IN_PROGRESS ||
        callStatus === actionTypes.CALL_OUTGOING)
    ) {
      timer.start();
    }

    // return () => {
    //   if (!mounted.current) {
    //     timer.stop();
    //   }
    // };

    return () => {
      timer.off('secondsUpdated', callCounter);
    };
  });

  return (
    <Typography
      id={id}
      style={{ color: `${colors.white}`, fontSize: 11, textAlign: 'end' }}
      className="iconWhite timer">
      {timeNow}
    </Typography>
  );
}

TimerCount.defaultProps = {
  answered: false,
  callStatus: false,
};

TimerCount.propTypes = {
  id: lib.PropTypes.string.isRequired,
  timerRinging: lib.PropTypes.instanceOf(Object).isRequired,
  timerDuring: lib.PropTypes.instanceOf(Object).isRequired,
  answered: lib.PropTypes.bool,
  callStatus: lib.PropTypes.string,
};
